import 'whatwg-fetch';

console.info('--polyfill--');
